import React from 'react';
import { Tabs } from 'antd';
import { GenericReportingDropdowns } from '../../containers/GenericReportingDropdowns';
import SettingsDropdowns from '../../containers/PaidMedia.js/SettingsDropdowns';
import Reporting from '../../containers/PaidMedia.js/Reporting';

function Tiktok() {

    const tabs = [
        {
            label: 'Settings',
            key: 'Settings',
            children: [<SettingsDropdowns platform='tiktok'></SettingsDropdowns>]
        },
        {
            label: 'Reporting',
            key: 'Reporting',
            children: [<Reporting platform='tiktok'></Reporting>]
        }
    ]

    return (
        // JSX code for your component's UI goes here
        <div>
            <Tabs style={{
                'width': '80vw',
                'marginLeft': '1vw',
            }} items={tabs} defaultActiveKey='Reporting' ></Tabs>
        </div>
    );
}

export default Tiktok;